/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Offset_TimecodeInputs */



/**
* | output |
* | --- |
* | "Offset the timecode of the selected event(s) based on the playhead position" |
*
* @param {Shortcut_Keys_Desc_Offset_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_offset_timecode = /** @type {((inputs?: Shortcut_Keys_Desc_Offset_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Offset_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decaler le timecode des evenements selectionnes selon la position de la tete de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschieben Sie den Timecode des/der ausgewählten Ereignisse(s) basierend auf der Abspielkopfposition.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta il codice temporale degli eventi selezionati in base alla posizione della testina di riproduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сместите временной код выбранного события (событий) в соответствии с положением ползунка воспроизведения.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazar el código de tiempo de los eventos seleccionados en función de la posición del cabezal de reproducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("根据播放头位置偏移所选事件的时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("再生ヘッドの位置に基づいて、選択したイベントのタイムコードをオフセットします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्लेहेड की स्थिति के आधार पर चयनित इवेंट के टाइमकोड को ऑफसेट करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ajuste o código de tempo do(s) evento(s) selecionado(s) com base na posição do indicador de reprodução.")
	return /** @type {LocalizedString} */ ("Offset the timecode of the selected event(s) based on the playhead position")
});